import React from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import _ from 'lodash';
import styles from './style.module.scss';
import { Modal, Form, Checkbox, Button, Input, Select, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
const { Option } = Select;
interface IProps {
  visible: boolean;
  onOk: () => void;
  onCancel?: () => void;
}
export default function ModalAlert({ visible, onOk, onCancel }: IProps) {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  return (
    <Modal visible={visible} onOk={onOk} centered footer={null} wrapClassName={styles.modalSuccess}>
      <div className="centerElement minH150">
        <div>{t('common.contentAttention')}</div>
      </div>
      <div className="centerElement">
        <Button className="buttonDefault buttonFormCancel" onClick={onCancel}>
          {t('common.buttonBack')}
        </Button>
        <Button className="buttonDefault buttonFormSubmitBlue" onClick={onOk}>
          {t('common.buttonOk')}
        </Button>
      </div>
    </Modal>
  );
}
